// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/crm/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/crm/convertLead */
export const useConvertLead = makeBackendHook('crm', 'convertLead')

/** POST /api/rpc/crm/createLead */
export const useCreateLead = makeBackendHook('crm', 'createLead')

/** POST /api/rpc/crm/deleteCommunication */
export const useDeleteCommunication = makeBackendHook('crm', 'deleteCommunication')

/** POST /api/rpc/crm/deleteEmailTemplate */
export const useDeleteEmailTemplate = makeBackendHook('crm', 'deleteEmailTemplate')

/** POST /api/rpc/crm/deleteLead */
export const useDeleteLead = makeBackendHook('crm', 'deleteLead')

/** POST /api/rpc/crm/enrichContact */
export const useEnrichContact = makeBackendHook('crm', 'enrichContact')

/** POST /api/rpc/crm/generateEmailContent */
export const useGenerateEmailContent = makeBackendHook('crm', 'generateEmailContent')

/** POST /api/rpc/crm/getCommunications */
export const useGetCommunications = makeBackendHook('crm', 'getCommunications')

/** POST /api/rpc/crm/getContactEmails */
export const useGetContactEmails = makeBackendHook('crm', 'getContactEmails')

/** POST /api/rpc/crm/getCrmSettings */
export const useGetCrmSettings = makeBackendHook('crm', 'getCrmSettings')

/** POST /api/rpc/crm/getCustomerContacts */
export const useGetCustomerContacts = makeBackendHook('crm', 'getCustomerContacts')

/** POST /api/rpc/crm/getCustomerDetail */
export const useGetCustomerDetail = makeBackendHook('crm', 'getCustomerDetail')

/** POST /api/rpc/crm/getCustomerInvoices */
export const useGetCustomerInvoices = makeBackendHook('crm', 'getCustomerInvoices')

/** POST /api/rpc/crm/getEmailSignature */
export const useGetEmailSignature = makeBackendHook('crm', 'getEmailSignature')

/** POST /api/rpc/crm/getEmailTemplates */
export const useGetEmailTemplates = makeBackendHook('crm', 'getEmailTemplates')

/** POST /api/rpc/crm/getEmailVoice */
export const useGetEmailVoice = makeBackendHook('crm', 'getEmailVoice')

/** POST /api/rpc/crm/getLeadDetail */
export const useGetLeadDetail = makeBackendHook('crm', 'getLeadDetail')

/** POST /api/rpc/crm/getLeads */
export const useGetLeads = makeBackendHook('crm', 'getLeads')

/** POST /api/rpc/crm/getPriceSheet */
export const useGetPriceSheet = makeBackendHook('crm', 'getPriceSheet')

/** POST /api/rpc/crm/getPriceSheetPhoto */
export const useGetPriceSheetPhoto = makeBackendHook('crm', 'getPriceSheetPhoto')

/** POST /api/rpc/crm/getReorderReminders */
export const useGetReorderReminders = makeBackendHook('crm', 'getReorderReminders')

/** POST /api/rpc/crm/sendMessage */
export const useSendMessage = makeBackendHook('crm', 'sendMessage')

/** POST /api/rpc/crm/setPriceSheetExclusions */
export const useSetPriceSheetExclusions = makeBackendHook('crm', 'setPriceSheetExclusions')

/** POST /api/rpc/crm/syncInboundEmails */
export const useSyncInboundEmails = makeBackendHook('crm', 'syncInboundEmails')

/** POST /api/rpc/crm/updateCrmSettings */
export const useUpdateCrmSettings = makeBackendHook('crm', 'updateCrmSettings')

/** POST /api/rpc/crm/updateCustomerNotes */
export const useUpdateCustomerNotes = makeBackendHook('crm', 'updateCustomerNotes')

/** POST /api/rpc/crm/updateEmailSignature */
export const useUpdateEmailSignature = makeBackendHook('crm', 'updateEmailSignature')

/** POST /api/rpc/crm/updateEmailVoice */
export const useUpdateEmailVoice = makeBackendHook('crm', 'updateEmailVoice')

/** POST /api/rpc/crm/updateEnrichment */
export const useUpdateEnrichment = makeBackendHook('crm', 'updateEnrichment')

/** POST /api/rpc/crm/updateLead */
export const useUpdateLead = makeBackendHook('crm', 'updateLead')

/** POST /api/rpc/crm/uploadEmailImage */
export const useUploadEmailImage = makeBackendHook('crm', 'uploadEmailImage')

/** POST /api/rpc/crm/upsertEmailTemplate */
export const useUpsertEmailTemplate = makeBackendHook('crm', 'upsertEmailTemplate')
